import { createContext, useContext, useMemo, useState } from 'react';

const DocumentZoomContext = createContext(null);

/**
 * Shares a document's fit-to-width state with chrome rendered outside it — a
 * modal header can host the zoom toggle while `DocumentPages`, further down the
 * tree, owns the scaling. Without a provider `DocumentPages` keeps the toggle
 * inline, so the context is optional for every consumer.
 */
export const DocumentZoomProvider = ({ children }) => {
  const [canZoom, setCanZoom] = useState(false);
  const [isActualSize, setIsActualSize] = useState(false);

  const value = useMemo(
    () => ({
      canZoom,
      setCanZoom,
      isActualSize,
      toggleActualSize: () => setIsActualSize((previous) => !previous)
    }),
    [canZoom, isActualSize]
  );

  return <DocumentZoomContext.Provider value={value}>{children}</DocumentZoomContext.Provider>;
};

export const useDocumentZoom = () => useContext(DocumentZoomContext);
